export type SingleLineTextFieldPublicValue = string;
export type SingleLineTextFieldInternalValue = string | undefined;

export const singleLineTextFieldGetValueTransformer = (
    internalValue: SingleLineTextFieldInternalValue
): SingleLineTextFieldPublicValue => (internalValue !== undefined ? internalValue : '');
